/* eslint-disable @typescript-eslint/no-unused-vars */
import { brand } from '../../theme/themePrimitives';
import CardWrapper from '../wrapper/card';
import { CustomerObject } from '../../params/redux/customer';
import DeleteCustomerModal from '../customer_management/modal/delete_customer';
import EditCustomerModal from '../customer_management/modal/edit_customer';
import InviteCustomerModal from '../customer_management/modal/invite_customer';
import LabelWrapper from '../wrapper/label';
import { settingSelectedCustomer } from '../../redux/slices/customer';
import { useState } from 'react';
import { AddCircleOutline, DeleteOutlined, EditOutlined, List } from '@mui/icons-material';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, CircularProgress, Divider, IconButton, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

const ClientTeamComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { customers, loaders } = useSelector((state: RootState) => state.customer);
    const [isAddingContact, setisAddingContact] = useState<boolean>(false);
    const [isEditingContact, setIsEditingContact] = useState<boolean>(false);
    const [isDeleting, setIsDeleting] = useState<boolean>(false);

    const deleteHandler = (contact: CustomerObject) => {
        dispatch(settingSelectedCustomer(contact));
        setIsDeleting(true);
    };
    const editHandler = (contact: CustomerObject) => {
        dispatch(settingSelectedCustomer(contact));
        setIsEditingContact(true);
    };

    const onModalCloseHandler = () => {
        setisAddingContact(false);
        setIsEditingContact(false);
        setIsDeleting(false);
        dispatch(settingSelectedCustomer(null));
    };

    if (loaders.isLoading) {
        return <CardWrapper minHeight="250px">
            <Box display="flex" alignItems="center" flexDirection="column" height="250px" justifyContent="center">
                <CircularProgress />
                <Typography variant="body2">Loading...</Typography>
            </Box>
        </CardWrapper>;
    }

    return (
        <Box maxHeight="250px" minHeight="250px" overflow="auto">
            <CardWrapper minHeight="250px">
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                    <Typography variant="h6" color="textSecondary">Team</Typography>
                    <Box>
                        <Button variant="outlined" startIcon={<AddCircleOutline />} onClick={() => setisAddingContact(true)}>
                            Invite Team Member
                        </Button>
                    </Box>
                </Box>
                <Divider />
                {
                    customers && customers?.length === 0
                        ? <Box my={1}>
                            <LabelWrapper label="No Team Member to display" />
                            <List color="info" fontSize="large" /></Box>
                        : customers.map((customer: CustomerObject, index: number) => (
                            <Box key={index} display="flex" justifyContent="space-between" alignItems="center" marginTop="10px" my={1}>
                                <Box display="flex" alignItems="center" gap={2}>
                                    <Box>
                                        <Typography variant="subtitle1" color="primary" fontWeight={600}>{`${customer?.first_name || ''} ${customer?.last_name || ''}` || 'Contact Name is Empty'}</Typography>
                                        <Typography variant="subtitle2" color="primary">
                                            {customer?.phone_number || 'Phone Number is empty'}
                                        </Typography>
                                    </Box>
                                    {customer.is_primary === 1 && <Box px={2} borderRadius={1} py="0.1rem" bgcolor={brand[50]} color={brand[300]} height="max-content">
                                        <Typography variant="body1" fontWeight="bold">Primary</Typography>
                                    </Box>}
                                </Box>
                                <Box>
                                    <IconButton color="primary"><EditOutlined onClick={() => editHandler(customer)} /></IconButton>
                                    {customer.is_primary !== 1 && <IconButton color="error"><DeleteOutlined onClick={() => deleteHandler(customer)} /></IconButton>}
                                </Box>
                            </Box>
                        ))
                }
                {isEditingContact && <EditCustomerModal open={isEditingContact} onClose={onModalCloseHandler} />}
                {isDeleting && <DeleteCustomerModal open={isDeleting} onClose={onModalCloseHandler} />}
                {isAddingContact && <InviteCustomerModal open={isAddingContact} onClose={onModalCloseHandler} />}
            </CardWrapper>
        </Box>);
};

export default ClientTeamComponent;